import { BaseAPI } from "@asd/customer-portal-api/dist/base";

export class AxiosConfiguration {
  private api: BaseAPI;
  private pendingRequestCount = 0;

  public constructor(api: BaseAPI) {
    this.api = api;

    // @ts-ignore
    this.api.axios.interceptors.request.use(
      (config) => {
        this.pendingRequestCount++;
        return config;
      },
      (error) => Promise.reject(error),
    );

    // @ts-ignore
    this.api.axios.interceptors.response.use(
      (response) => {
        this.pendingRequestCount--;
        return response;
      },
      (error) => {
        this.pendingRequestCount--;
        throw error;
      },
    );
  }

  public getPendingRequestCount() {
    return this.pendingRequestCount;
  }
}

class AxiosConfigurations {
  private static instance: AxiosConfigurations;
  private instances: Map<string, AxiosConfiguration> = new Map();

  constructor() {
    if (AxiosConfigurations.instance) {
      return AxiosConfigurations.instance;
    }

    AxiosConfigurations.instance = this;
  }

  public createAxiosConfiguration(id: string, api: BaseAPI) {
    if (this.instances.has(id)) {
      throw new Error(`cannot create multiple AxiosConfigurations with id: ${id}`);
    }

    this.instances.set(id, new AxiosConfiguration(api));
    return this.getAxiosConfiguration(id);
  }

  public getAxiosConfiguration(id: string) {
    if (!this.instances.has(id)) {
      throw new Error(`cannot access AxiosConfiguration before creation (${id})`);
    }

    return this.instances.get(id);
  }
}

export default new AxiosConfigurations();
